@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Delaware</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }">
        <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
          @for (control of controls[0].option; track $index) {
            <axis-radio
              [hidden]="getRadioButtons(control)"
              class="{{ control.class }}"
              heading="{{ control.label }}"
              value="{{ control.select }}"
              name="{{ controls[0].formControlName }}"
            ></axis-radio>
          }
        </axis-radio-button-wrapper>
        @if (reactiveForm.get(controls[0].formControlName)?.touched) {
          @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
            <span class="axis-error-block">Please select an option.</span>
          }
        }
      </div>
      @if (baseRules["Required_Personal_Injury_Protection_Text"]?.includes("show")) {
        <div class="axis-form-group">
          <p class="axis-text">{{ textValues.Required_Personal_Injury_Protection_Text }}</p>
        </div>
      }
      <div class="axis-form-group _mt-medium _ml-medium">
        @if (baseRules["RequiredSplitLimits_DropDown"]?.includes("show")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[1].formControlName)?.value === null ||
                  reactiveForm.get(controls[1].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
              }">
              <label
                class="axis-control-label"
                for="{{ controls[1].formControlName }}"
                >{{ controls[1].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span>
              </label>
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </div>
          </div>
        }
        
        @if ( baseRules?.["RequiredSplitLimits_DropDown"]?.includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[1].label }}</label>
              <div
                id="requiredsplitlimits_15k_30k-pdffield-delaware"
              >
                {{ controls[1].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if (baseRules["RequiredCombinedSingleLimit_DropDown"]?.includes("show")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[2].formControlName)?.value === null ||
                  reactiveForm.get(controls[2].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[2].formControlName)?.touched &&
                  reactiveForm.get(controls[2].formControlName)?.invalid,
              }">
              <label
                class="axis-control-label"
                for="{{ controls[2].formControlName }}"
                >{{ controls[2].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span>
              </label>
              <axis-dropdown
                [dataProvider]="controls[2].data"
                id="{{ controls[2].formControlName }}"
                formControlName="{{ controls[2].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </div>
          </div>
        }
        @if ( baseRules?.["RequiredCombinedSingleLimit_DropDown"]?.includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[2].label }}</label>
              <div
                id="requiredcombinedsinglelimit_30k-pdffield-delaware"
              >
                {{ controls[2].data[0].name }}
              </div>
            </div>
          </div>
        }
        
      </div>
      @if (baseRules["Added_Personal_Injury_Protection_Text"]?.includes("show")) {
        <div class="axis-form-group">
          <p class="axis-text">{{ textValues.Added_Personal_Injury_Protection_Text }}</p>
        </div>
      }
      <div class="axis-grid _ml-medium _mt-medium">
        @if (baseRules["AdditionalSplitLimits_DropDown"]?.includes("show")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[3].formControlName)?.value === null ||
                  reactiveForm.get(controls[3].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[3].formControlName)?.touched &&
                  reactiveForm.get(controls[3].formControlName)?.invalid,
              }">
              <label
                class="axis-control-label"
                for="{{ controls[3].formControlName }}"
                >{{ controls[3].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span>
              </label>
              <axis-dropdown
                [dataProvider]="controls[3].data"
                id="{{ controls[3].formControlName }}"
                formControlName="{{ controls[3].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </div>
          </div>
        }
        @if (baseRules["AdditionalCombinedSingleLimit_DropDown"]?.includes("show")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[4].formControlName)?.value === null ||
                  reactiveForm.get(controls[4].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[4].formControlName)?.touched &&
                  reactiveForm.get(controls[4].formControlName)?.invalid,
              }">
              <label
                class="axis-control-label"
                for="{{ controls[4].formControlName }}"
                >{{ controls[4].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span>
              </label>
              <axis-dropdown
                [dataProvider]="controls[4].data"
                id="{{ controls[4].formControlName }}"
                formControlName="{{ controls[4].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[4].formControlName)?.touched) {
                @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
                }
              }
            </div>
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Delaware</h2>
  <div class="axis-grid">
    @if (baseRules?.RequiredCombinedSingleLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">
            {{ baseRules["selectionId"] === 'NonGarage' ? 'PIP Single Limit (Each Accident):' : controls[2].label}}
          </label>
          <div>{{ controls[2].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
